import LoadScene from '@scenes/LoadScene';
import StartScene from '@scenes/StartScene';
import GameScene from '@scenes/GameScene';
import HintScene from '@scenes/HintScene';
import EndScene from '@scenes/EndScene';

export default [
  { key: 'LoadScene', scene: LoadScene, autoStart: true },
  { key: 'StartScene', scene: StartScene },
  { key: 'GameScene', scene: GameScene },
  { key: 'HintScene', scene: HintScene },
  { key: 'EndScene', scene: EndScene },
];
